module.exports = __webpack_public_path__ + "static/media/saloon-car.be9d7b77.png";